import type { Match } from '../types';

/** Compact one-line match: "You + Jānis  4–3  Edgars + Raivis". Highlights the viewer's side. */
export default function MatchLine({ m, names, me, label }: { m: Match; names: Record<string, string>; me?: string; label?: string }) {
  const n = (id: string) => names[id] ?? '?';
  const mine = me ? (m.a.includes(me) ? 'a' : m.b.includes(me) ? 'b' : null) : null;
  const played = m.scoreA != null;
  const won = played && mine ? (mine === 'a' ? m.scoreA! > m.scoreB! : m.scoreB! > m.scoreA!) : null;
  return (
    <div className="text-sm">
      {label && <div className="text-[11px] text-dim uppercase tracking-wider">{label} · R{m.round} C{m.court}</div>}
      <div className="flex items-center gap-2">
        <span className={`flex-1 truncate ${mine === 'a' ? 'font-medium' : 'text-dim'}`}>{n(m.a[0])} + {n(m.a[1])}</span>
        <span className={`stat px-2 rounded-lg ${played ? (won === true ? 'bg-ball-500/15 text-ball-300' : won === false ? 'bg-danger/10 text-danger' : 'bg-ink-800') : 'bg-ink-800 text-dim'}`}>
          {played ? `${m.scoreA}–${m.scoreB}` : (m.startA || m.startB ? `${m.startA}–${m.startB}` : '–')}
        </span>
        <span className={`flex-1 truncate text-right ${mine === 'b' ? 'font-medium' : 'text-dim'}`}>{n(m.b[0])} + {n(m.b[1])}</span>
      </div>
    </div>
  );
}
